module.exports = __webpack_public_path__ + "static/media/1.2 Vinckboons waehrend FA klein.cf4eea06.jpg";